import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import '../css/cards.css';

const CopyButton = React.memo(({ text }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const handleCopy = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!text) return;
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      className={`copy-btn ${copied ? 'copied' : ''}`}
      onClick={handleCopy}
      title={copied ? t('common.copied') : t('common.copy')}
    >
      <Icon name={copied ? 'check' : 'copy'} size={12} />
    </button>
  );
});

export default CopyButton;
